import type { ComponentType } from 'react';
import React from 'react';
import { RoutingStateContainer } from './container';

export const withRoutingStateContainer = <TProps extends object>(
	WrappedComponent: ComponentType<TProps>,
) => {
	const WithRoutingStateContainer: React.FC<TProps & { contextId: string }> = (props) => {
		const { contextId } = props;

		return (
			<RoutingStateContainer contextId={contextId} isGlobal>
				<WrappedComponent {...props} />
			</RoutingStateContainer>
		);
	};

	return WithRoutingStateContainer;
};
